import "./components/js-form-validator";
import Stepper from "./components/stepper";
import TetherSelect from "tether-select";
//import Litepicker from "litepicker";
import validatorOptions from "./components/validatorOptions";

(function () {
    const steps = document.querySelectorAll(".stepper__step");
    const stepsWrapper = document.querySelector(".stepper");
    const nextStepButton = document.querySelector(".stepper__next");
    const prevStepButton = document.querySelector(".stepper__previous");
    const submitButton = document.querySelector(".stepper__submit");
    const progressBar = document.querySelector(".stepper__progressBar");

    const validator = [];
    for (let i = 0; i < steps.length; i++) {
        const fieldset = document.getElementById("formStep" + (i + 1));
        if (fieldset) {
            validator[i] = new Validator(
                fieldset,
                function (err, res) {
                    return res;
                },
                validatorOptions
            );
            let k = i;
            for (const element of fieldset.elements) {
                element.addEventListener("change", function () {
                    setTimeout(function () {
                        if (validator[k].validate()) {
                            nextStepButton.disabled = false;
                            submitButton.disabled = false;
                        } else {
                            nextStepButton.disabled = true;
                            submitButton.disabled = true;
                            validator[k].showErrors();
                        }
                    }, 50);
                });

                element.addEventListener('keydown', function () {
                    setTimeout(function () {
                        if (validator[k].validate()) {
                            nextStepButton.disabled = false;
                            submitButton.disabled = false;
                        }
                    }, 50);
                });
            }
        }
    }

    /*const radio = document.querySelectorAll("input[name=donationAmount]");
    const input = document.getElementById("donationAmountCustomValue");
    
    for (let i = 0; i < radio.length; i++) {
        radio[i].addEventListener("change", function (e) {
            if (this.value === "custom") {
                input.dataset.rule = "required";
            } else {
                input.dataset.rule = "";
            }
            validator[0].reload();
            if (validator[0].validate()) {
                nextStepButton.disabled = false;
            } else {
                nextStepButton.disabled = true;
                validator[0].showErrors();
            }
        });
    }*/

    /*var checkbox = document.getElementById("donationIsCompany");
    var input = document
    .getElementById("companyWrapper")
    .querySelectorAll("input");
    
    checkbox.addEventListener("change", function (e) {
        if (this.checked) {
            input.forEach(function (elem) {
                elem.dataset.rule = "required";
            });
        } else {
            input.forEach(function (elem) {
                elem.dataset.rule = "";
            });
        }
        validator[1].reload();
        if (validator[1].validate()) {
            nextStepButtons[1].disabled = false;
        } else {
            nextStepButtons[1].disabled = true;
            validator[1].showErrors();
        }
    });*/



    const stepper = new Stepper(
        steps,
        stepsWrapper,
        nextStepButton,
        prevStepButton,
        submitButton,
        progressBar,
        validator
    );

    /*const dateInput = document.getElementById('weddingFormDate');
    const datepicker = new Litepicker({
        element: dateInput,
        lang: 'pl',
        minDate: new Date(),
        autoRefresh: true,
        onSelect: function () {
            if ('createEvent' in document) {
                const evt = document.createEvent('HTMLEvents');
                evt.initEvent('change', false, true);
                dateInput.dispatchEvent(evt);
            } else dateInput.fireEvent('onchange');
        }
    });*/

    const selectFields = document.querySelectorAll("select");

    for (const select of selectFields) {
        new TetherSelect({
            el: select,
            className: 'select-theme-swm'
        })
    }
})();